import { Keccak256Hasher } from '../hashers';
export var Platform;
(function (Platform) {
    Platform[Platform["ckb"] = 0] = "ckb";
    Platform[Platform["eth"] = 1] = "eth";
    Platform[Platform["eos"] = 2] = "eos";
    Platform[Platform["tron"] = 3] = "tron";
    // libra
})(Platform || (Platform = {}));
export class Provider {
    constructor(platform) {
        this.platform = platform;
    }
    get address() {
        return this._address;
    }
    set address(value) {
        this._address = value;
    }
    hasher() {
        return new Keccak256Hasher();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcHJvdmlkZXJzL3Byb3ZpZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBVSxlQUFlLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFFckQsTUFBTSxDQUFOLElBQVksUUFNWDtBQU5ELFdBQVksUUFBUTtJQUNsQixxQ0FBTyxDQUFBO0lBQ1AscUNBQUcsQ0FBQTtJQUNILHFDQUFHLENBQUE7SUFDSCx1Q0FBSSxDQUFBO0lBQ0osUUFBUTtBQUNWLENBQUMsRUFOVyxRQUFRLEtBQVIsUUFBUSxRQU1uQjtBQUVELE1BQU0sT0FBZ0IsUUFBUTtJQUM1QixZQUE0QixRQUFrQjtRQUFsQixhQUFRLEdBQVIsUUFBUSxDQUFVO0lBQUcsQ0FBQztJQUdsRCxJQUFJLE9BQU87UUFDVCxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUM7SUFDdkIsQ0FBQztJQUNELElBQUksT0FBTyxDQUFDLEtBQWM7UUFDeEIsSUFBSSxDQUFDLFFBQVEsR0FBRyxLQUFLLENBQUM7SUFDeEIsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUksZUFBZSxFQUFFLENBQUM7SUFDL0IsQ0FBQztDQU9GIn0=